// @core/api/endpoints/subscription/cancel_tenant_subscription.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';

const BASE_PATH = '/subscription';

/**
 * Cancel tenant subscription
 * Cancels the tenant's subscription to a product. The tenant loses access to the product and associated features.
 */
export async function CancelTenantSubscription(
  tenant_id: string,
  product_id: string,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/tenants/:tenant_id/products/:product_id`;
  requestPath = requestPath.replace(':tenant_id', encodeURIComponent(tenant_id));
  requestPath = requestPath.replace(':product_id', encodeURIComponent(product_id));
  const requestOptions = options;
  return client.delete<Response>(requestPath, requestOptions);
}
